module.exports = __webpack_public_path__ + "static/media/iot-logo-full.a62030ad.svg";